import React, { useMemo } from 'react'
import { mutualTheme } from '~/utils/theme'
import { AddDocumentIcon } from '~/assets/icons'
import { makeStyles } from '@material-ui/styles'
import { Box, Typography } from '@material-ui/core'
import { useIsMobileScreen } from '~/hooks'

export type AddNewDocumentButtonProps = {
  label?: string,
  onClick: () => void
}

const useStyles = makeStyles({
  iconContainer: {
    width: 40,
    height: 40,
    alignItems: 'center',
    justifyContent: 'center',
    padding: mutualTheme.spacing(1),
    borderRadius: mutualTheme.spacing(1),
    backgroundColor: mutualTheme.palette.badgeBorderColor.info.main
  },
  dropArea: {
    borderRadius: 10,
    border: `2px dashed ${mutualTheme.palette.grey.A200}`
  },
  label: {
    marginLeft: mutualTheme.spacing(2),
    fontWeight: mutualTheme.typography.fontWeightMedium,
    [mutualTheme.breakpoints.down('md')]: {
      marginLeft: mutualTheme.spacing(1)
    }
  },
  cursorStyle: {
    cursor: 'pointer'
  }
})

export const AddNewDocumentButton: React.FC<AddNewDocumentButtonProps> = (props) => {
  const { label, onClick } = props
  const classes = useStyles()
  const spaceBetween = useMemo(() => label && { justifyContent: 'space-between' }, [label])
  const isMobile = useIsMobileScreen()

  return (
    <Box onClick={onClick} className={classes.dropArea}>
      <Box sx={{ padding: isMobile ? 0.5 : 1, flex: '1' }} className={classes.cursorStyle}>
        <Box sx={{ display: 'flex', alignItems: 'center', ...spaceBetween }}>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <Box className={classes.iconContainer}>
              <AddDocumentIcon htmlColor={mutualTheme.palette.secondary.main} height={24} width={24} />
            </Box>
            <Typography color='secondary' variant={isMobile ? 'airbnbBody2' : 'airbnbBody1'} className={classes.label}>Adicionar outro arquivo</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
